import { Row } from 'react-table';
import { compareDates } from 'shared/utility';
import { CONTRACT_STATUS } from 'shared/constants';
import { CustomerContractInventoryGridItem } from 'shared/types/customerManagement';

export const sortContractStatus = (
  rowA: Row<CustomerContractInventoryGridItem>,
  rowB: Row<CustomerContractInventoryGridItem>,
  columnId: string
) => {
  const isRowAContractExpired = compareDates(new Date(rowA.original.endDate), new Date()) === 1;
  const isRowBContractExpired = compareDates(new Date(rowB.original.endDate), new Date()) === 1;
  const a = isRowAContractExpired
    ? CONTRACT_STATUS['inactive']
    : CONTRACT_STATUS[rowA.values[columnId] as keyof typeof CONTRACT_STATUS];
  const b = isRowBContractExpired
    ? CONTRACT_STATUS['inactive']
    : CONTRACT_STATUS[rowB.values[columnId] as keyof typeof CONTRACT_STATUS];
  if (a > b) return 1;
  if (a < b) return -1;
  return 0;
};
